<div class="container tw-p-[5%] md:tw-p-[2%] lg:tw-p-0">
  <div class="tw-flex tw-flex-col tw-items-center tw-py-[5%] md:tw-py-[10%]">
    <p class="tw-text-center tw-text-xl md:tw-text-2xl lg:tw-text-3xl tw-font-extrabold tw-capitalize">What is all-inclusive smart car subscription?</p>

    <p class="tw-text-center tw-pb-12  tw-pt-4 md:tw-pt-6 md:tw-px-[10%] tw-text-gray-700">PumPumPum is India's first monthly car subscription service offering
      certified  pre-owned cars <br> for personal and business use in a flexible and affordable way.</p>

    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4">
      <div class="tw-border tw-border-[#C9C9C9] tw-rounded-md tw-shadow-md tw-p-4 tw-flex md:tw-flex-col tw-gap-2"
        *ngFor="let item of noHassles;">
        <!-- <div class=""> -->
          <div class="tw-bg-yellowLight tw-p-3 tw-rounded-md tw-shrink-0 tw-w-14 tw-h-14 tw-flex tw-items-center tw-justify-center">
            <img class="tw-w-14" [src]="item.icon" [alt]="item.title">
          <!-- </div> -->
        </div>
        <div class="tw-flex-1">
          <p class="tw-font-bold">{{item.title}}</p>
          <p class="tw-text-gray-700 tw-text-sm">{{item.description}}</p>
        </div>
      </div>
    </div>
  </div>
</div>